(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-page-landing-findit"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ps-lp--findit');
  if (!root) return;

  var typedEl  = root.querySelector('[data-typed]');
  var labelEl  = root.querySelector('[data-label]');
  var states   = root.querySelectorAll('.psf-demo-state');
  if (!typedEl || !states.length) return;

  function show(key) {
    for (var i = 0; i < states.length; i++) {
      states[i].hidden = (states[i].getAttribute('data-state') !== key);
    }
    if (labelEl) labelEl.textContent = key;
  }

  // Reduced motion or no observer: leave the settled "leafs" frame as rendered.
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (still) { typedEl.textContent = 'leafs'; show('leafs'); return; }

  // The reel: type l-e-a-f-s, pausing on the three query states long enough to
  // read the result, then hold the finished state and loop. Mirrors the real
  // finder: nothing fires below 2 chars, results settle a beat after typing stops.
  var WORD = 'leafs';
  // frames: [text shown, ms to hold, result-state key or null]
  var reel = [
    ['l',     260,  null],     // 1 char — under the floor, no results yet
    ['le',    1500, 'le'],     // driving light
    ['lea',   1700, 'lea'],    // extension lead jumps in
    ['leaf',  260,  'leafs'],  // lead drops out, springs settle
    ['leafs', 2600, 'leafs'],  // finished — hold so it can be read
    ['leafs', 700,  'leafs'],  // brief beat before clearing
    ['',      450,  null]      // clear, then loop
  ];

  var i = 0, timer = null, started = false;

  function step() {
    var f = reel[i];
    typedEl.textContent = f[0];
    if (f[2]) show(f[2]);
    i = (i + 1) % reel.length;
    timer = setTimeout(step, f[1]);
  }

  function start() {
    if (started) return;
    started = true;
    show('le');
    typedEl.textContent = '';
    step();
  }

  // Only run the reel while the demo is on screen — no point animating unseen,
  // and it means the visitor catches it from the top rather than mid-loop.
  var demo = root.querySelector('.psf-demo');
  if ('IntersectionObserver' in window && demo) {
    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) { start(); io.disconnect(); return; }
      }
    }, { threshold: 0.4 });
    io.observe(demo);
  } else {
    start();
  }

  // ── Pin to Finder demo: product frame → pin flips → finder frame, on a loop ──
  var pindemo = root.querySelector('[data-pindemo]');
  if (pindemo) {
    var pinBtn   = pindemo.querySelector('[data-pin]');
    var pinLabel = pindemo.querySelector('[data-pin-label]');
    var fProduct = pindemo.querySelector('[data-frame="product"]');
    var fFinder  = pindemo.querySelector('[data-frame="finder"]');
    var pinStill = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var PIN_PINNED = 'Pinned \u2713 <span class="pp-pin-hint">\u2014 click to remove</span>';

    function pinReset() {
      pinBtn.classList.remove('is-pinned');
      pinLabel.textContent = 'Pin to Finder';
      fProduct.hidden = false;
      fFinder.hidden = true;
    }
    function pinFlip() { pinBtn.classList.add('is-pinned'); pinLabel.innerHTML = PIN_PINNED; }
    function toFinder() { fProduct.hidden = true; fFinder.hidden = false; }

    function pinLoop() {
      pinReset();
      setTimeout(pinFlip, 1500);     // sit on the product, then pin
      setTimeout(toFinder, 3000);    // reveal it waiting in the finder
      setTimeout(pinLoop, 6500);     // hold the finder, then loop
    }

    if (pinStill) {
      // static honest end-state: pinned, sitting in the finder
      pinFlip(); toFinder();
    } else if ('IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (entries) {
        for (var m = 0; m < entries.length; m++) {
          if (entries[m].isIntersecting) { pinLoop(); pio.disconnect(); return; }
        }
      }, { threshold: 0.4 });
      pio.observe(pindemo);
    } else {
      pinLoop();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-page-landing-general"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.ps-lp--general');
  if(!root) return;
  var typed = root.querySelector('[data-typed]');
  var resolve = root.querySelector('[data-resolve]');
  var resolveTxt = root.querySelector('[data-resolve-txt]');
  if(!typed || !resolve || !resolveTxt) return;

  // Real catalogue entries — query strings are actual alias metafield values,
  // resolved titles are prefix-true excerpts of the real product titles.
  // Source: products_export_25-07-2026. SKUs in comments; do not invent additions.
  var demos = [
    ["grease cap", "Dust Cap 2\" Zinc Plated"],        // DC2
    ["leafs",      "Slipper Spring 45mm 5-Leaf Kit"],  // SS45-5S
    ["diff oil",   "Valvoline HP Gear Oil 80W-90"],    // 1398.04
    ["towbal",     "ARK Chrome Tow Ball 50mm 2000kg"], // TB50HR1
    ["h7 bulb",    "Hella H7 Halogen Globe 12V 55W"]   // 8GH 211 730-511
  ];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var di = 0;

  if(reduce){
    typed.textContent = demos[0][0];
    resolveTxt.textContent = demos[0][1];
    resolve.classList.add('is-show');
    var caret = root.querySelector('.ps-lp__caret');
    if(caret) caret.style.display = 'none';
    return;
  }

  function run(){
    var pair = demos[di], q = pair[0], part = pair[1], i = 0;
    resolve.classList.remove('is-show');
    typed.textContent = '';
    (function type(){
      if(i <= q.length){ typed.textContent = q.slice(0,i); i++; setTimeout(type, 70); }
      else { resolveTxt.textContent = part; resolve.classList.add('is-show'); setTimeout(next, 1900); }
    })();
  }
  function next(){ di = (di+1) % demos.length; run(); }
  run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-page-landing-nopopups"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ps-lp--nopopups');
  if (!root) return;

  var list = root.querySelector('.ps-lp__gone');
  if (!list) return;

  // No IntersectionObserver, or the visitor asked for less motion:
  // leave the lines struck as they render. Nothing to do.
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (still || !('IntersectionObserver' in window)) return;

  list.classList.add('ps-lp__gone--anim');

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        list.classList.add('is-struck');
        io.disconnect();
        return;
      }
    }
  // Fires as soon as a bit of the list is on screen. No rootMargin — squeezing
  // the detection band toward the middle made it fire too late on a phone,
  // where the list is most of the screen height to begin with.
  }, { threshold: 0.15 });

  io.observe(list);
})();

  } catch(e) { console.error(e); }
})();
})();
